import { useCallback, useMemo } from 'react';
import { t } from 'i18next';

import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { SnackbarServiceFactory } from '@/modules/snackbar/service/SnackbarServiceFactory';

export const useDoesVehiclesHaveLoadTypeCheck = () => {
  const getVehicleDetailsByIds = useVehicleStore((state) => state.vehicleDetails.getByIds);
  const snackbarSvc = useMemo(
    () => SnackbarServiceFactory.getInstance().createSnackbarService(),
    [],
  );

  /**
   * @description
   * checks if the provided vehicles have any usable load types of the ones provided. If not, messages the user with a snackbar.
   */
  const doesVehiclesHaveLoadType = useCallback(
    (vehicleIds: string[], loadTypeIds: string[]) => {
      const enabledVehicleDetails = getVehicleDetailsByIds(vehicleIds);
      const vehiclesWithoutLoadTypes = enabledVehicleDetails.filter(
        (vehicle) => !vehicle.loadTypes.some((loadType) => loadTypeIds.includes(loadType)),
      );
      if (vehiclesWithoutLoadTypes.length > 0) {
        const vehicleNames = vehiclesWithoutLoadTypes.map((vehicle) => vehicle.id).join(', ');
        snackbarSvc.showMessage(
          t('interface:setup.floorPlan.messages.vehicles_without_load_types', {
            vehicles: vehicleNames,
          }),
        );
      }
    },
    [getVehicleDetailsByIds, snackbarSvc],
  );

  return { doesVehiclesHaveLoadType };
};
